import { render, staticRenderFns } from "./searchMembersPage.vue?vue&type=template&id=0965e75c&scoped=true&"
import script from "./searchMembersPage.vue?vue&type=script&lang=js&"
export * from "./searchMembersPage.vue?vue&type=script&lang=js&"
import style0 from "./searchMembersPage.vue?vue&type=style&index=0&id=0965e75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0965e75c",
  null
  
)

export default component.exports